import { Box, Flex, Heading } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useColor } from '../../theme'

interface ITileRowProps {
  heading: string
  children?: React.ReactNode
}

const TileRow: FC<ITileRowProps> = ({ heading, children }) => {
  const headingColor = useColor({ nuance: 3, palette: 'text' })

  return (
    <Box>
      <Heading
        as="h2"
        color={headingColor}
        fontSize="xl"
        fontWeight={700}
        lineHeight="1.5rem"
        marginBottom="1.5rem">
        {heading}
      </Heading>
      <Flex flexWrap="wrap" gap="2rem" justifyContent="start" margin="0 -1rem">
        {children}
      </Flex>
    </Box>
  )
}

export { TileRow }
